import { gql } from '@apollo/client';

const UpdateAppointment = gql`
  mutation UpdateAppointment($UpdateAppointmentInput: UpdateAppointmentInput!) {
    UpdateAppointment(UpdateAppointmentInput: $UpdateAppointmentInput) {
      id
      status
    }
  }
`;

const GetSyncedAppointmentStatus = gql`
  query GetSyncedAppointmentStatus($id: ID!) {
    getSyncedAppointmentStatus(id: $id) {
      id
      status
    }
  }
`;

export { UpdateAppointment, GetSyncedAppointmentStatus };
